import styled from 'styled-components';
import { VerifiedListProps } from 'components/PageWrappers/AdDetails/components/VerifiedList/VerifiedList.typed';

const P = styled.div<Pick<VerifiedListProps, 'layout'>>`
  ${({ theme, layout }) =>
    layout === 'SINGLE_LINE' ? theme.fontSize.S12 : theme.fontSize.M14};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.S4};
  white-space: nowrap;
  align-items: center;
`;

const VerifiedContainer = styled.div<Pick<VerifiedListProps, 'layout'>>`
  display: grid;
  row-gap: ${({ theme }) => theme.spacing.S8};
  column-gap: ${({ theme }) => theme.spacing.S8};
  grid-template-columns: ${({ layout }) =>
    layout === 'TWO_COLUMN' ? 'repeat(2, 1fr)' : 'repeat(4, min-content)'};

  @media (min-width: 1024px) {
    margin-bottom: ${({ theme, layout }) =>
      layout === 'TWO_COLUMN' && theme.spacing.L56};
    column-gap: ${({ theme }) => theme.spacing.S8};
  }

  ${P}:last-child {
    grid-column: ${({ layout }) => (layout === 'TWO_COLUMN' ? 'span 2' : '0')};
  }
`;

const SP = styled(P)`
  color: ${({ theme }) => theme.colors.GREY};
`;

export { VerifiedContainer, P, SP };
